import { schema } from "normalizr";

const centroidSchema = new schema.Entity("centroids", { idAttribute: "id" });

export default centroidSchema;



// WEBPACK FOOTER //
// ./src/schemas/centroid.js